import React, { FC } from 'react';
import { useTranslation } from 'next-i18next';
import classNames from 'classnames';

import getClassNames from 'src/common/utils/getClassNames';
import Icon from 'src/common/components/IconDS22';

import styles from './Modal.module.scss';
import CloseButton from '../CloseButton';

type ControllerProps = {
  /**
   * If present, Back button will display on left side.
   * @returns void
   */
  onBack?: () => void;
  /**
   * If present, Close button will display on right side.
   * @returns void
   */
  onClose?: () => void;
  /**
   * If present, a progress bar will display in center.
   */
  progress?: number;
  /**
   * Optional. If true, Back text will display.
   * If false and onBack is present, only Icon of 'caret-left' will display.
   */
  showBackText?: boolean;
  /**
   * Optional. If true, the Back button will be disabled.
   */
  isBackButtonDisabled?: boolean;
};

const Controller: FC<ControllerProps> = ({
  onBack,
  onClose,
  progress,
  showBackText,
  isBackButtonDisabled,
}) => {
  const [t] = useTranslation('common');

  return (
    <div className={getClassNames(styles, 'controller', classNames({ isWithBackButton: onBack }))}>
      {onBack && (
        <button
          className={styles.backButton}
          type="button"
          onClick={onBack}
          aria-label={t('common-modal--back-button')}
          disabled={isBackButtonDisabled}
        >
          <Icon id="caret-left" size="l" />
          {showBackText && <span className={styles.backText}>{t('common-modal--back-button')}</span>}
        </button>
      )}
      {progress && (
        'Progress Bar' // TODO: build this out when need arises
      )}
      {onClose && (
        <CloseButton
          onClick={onClose}
          aria-label={t('close-button-label')}
          size="large"
          position="static"
        />
      )}
    </div>
  );
};

export default Controller;
